import React, { useLayoutEffect, useState } from "react";
import { useWindowSize } from "../../../hooks/useWindowSize";
import UiNavbar from "../../Ui/Navbar";
import ResponsiveNavbar from "../../Ui/ResponsiveNavbar";

const Header = ({ setShow }) => {
  const size = useWindowSize();
  const [isSmallDevice, setSmallDevice] = useState();

  useLayoutEffect(() => {
    if (size.width <= 1024) {
      setSmallDevice(true);
    } else {
      setSmallDevice(false);
    }
  }, [size]);

  return (
    <>
      {isSmallDevice ? (
        <ResponsiveNavbar setShow={setShow} />
      ) : (
        <UiNavbar setShow={setShow} />
      )}
    </>
  );
};

export default Header;
